import useMenuBreakpoint from "../hooks/useMenuBreakpoint";
import React, { useEffect, useState } from "react";
import Container from "./Container";
import LinkHP from "./LinkHP";

const Menu = ({ url, secondary, structure }) => {
  const [, isTablet] = useMenuBreakpoint();
  const [showMenuLinks, setShowMenuLinks] = useState(!isTablet);

  const ctaItems =
    structure && structure.length > 0 ? structure[0]?.options?.items : [];

  useEffect(() => {
    setShowMenuLinks(!isTablet);
  }, [isTablet]);

  useEffect(() => {
    if (showMenuLinks && isTablet) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      return () => (document.body.style.overflow = originalStyle);
    }
  }, [showMenuLinks, isTablet]);

  const MenuLink = ({ item }) => {
    const [showSubmenu, setShowSubmenu] = useState(false);
    const [, isTablet] = useMenuBreakpoint();

    return (
      <li
        className={`font-500 relative ${isTablet ? "" : "underline-animation"}`}
        role="none"
        onMouseEnter={() => !isTablet && setShowSubmenu(true)}
        onMouseLeave={() => !isTablet && setShowSubmenu(false)}
      >
        <a
          href={item.url}
          role="menuitem"
          title={item.title}
          aria-label={item.title}
          className={`flex items-center justify-between mdMenu:h-full font-title`}
          onClick={(e) => {
            if (isTablet && item?.items?.length > 0) {
              e.preventDefault();
              setShowSubmenu((s) => !s);
            }
          }}
        >
          <p>{item.title}</p>
          {!isTablet || item?.items?.length === 0 ? null : (
            <svg
              className={`fill-white mdMenu:hidden mb-1 ${
                showSubmenu ? "rotate-svg" : ""
              }`}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="8"
              viewBox="0 0 12 6"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="m455.465 769.707-1.847-.974 3.478-5.054-3.475-4.989 1.841-.983 4.156 5.966z"
                transform="rotate(90 611.663 158.045)"
              ></path>
            </svg>
          )}
        </a>
        {item?.items && item.items.length > 0 ? (
          <ul
            className={`transition-all duration-300 ease-in-out ${
              isTablet
                ? `overflow-hidden -ml-6 -mr-6 bg-white ${
                    showSubmenu ? "max-h-96 py-2 mt-4" : "max-h-0 py-0 mt-0"
                  }`
                : `absolute left-0 top-full bg-white text-black shadow-lg md:w-72 origin-top ${
                    showSubmenu
                      ? "opacity-100 visible translate-y-0"
                      : "opacity-0 invisible -translate-y-2"
                  }`
            }`}
            role="menu"
          >
            {item.items.map((subItem, index) => (
              <li
                key={subItem.id}
                className={`text-sm text-black hover:bg-gray-200 hover:text-blueNavLink hover:bg-blueNavLinkBg `}
                role="none"
              >
                <div className="ml-6 mr-6 ">
                  <a
                    href={subItem.url}
                    className={`block px-2 py-2 ${
                      index < item.items.length - 1
                        ? "border-b border-black"
                        : ""
                    }`}
                    role="menuitem"
                    title={subItem.title}
                    aria-label={subItem.title}
                  >
                    {subItem.title}
                  </a>
                </div>
              </li>
            ))}
          </ul>
        ) : null}
      </li>
    );
  };

  return (
    <>
      <nav className="sticky top-0 z-30 text-white" id="main-menu">
        <Container
          className={`menu-animation w-full relative px-5 md:px-8 bg-black  text-base font-700`}
        >
          <div className="grid grid-cols-4 gap-4 md:grid-cols-12">
            <div className="flex flex-col flex-wrap w-full col-span-12 col-start-1 gap-5 mt-4 mb-4 whitespace-no-wrap md:mb-4 md:col-start-1 md:col-span-12 md:max-w-1220 md:mx-auto md2:col-start-1 md2:col-span-12 md2:max-w-1220 md2:m-auto md2:my-5 lg:col-start-1 lg:col-span-12 mdMenu:items-center smMenu:flex-row mdMenu:flex-no-wrap font-title">
              <h2
                className="flex items-center order-1 gap-4 text-xl font-bold cursor-pointer mdMenu:order-1 flex-nowrap simple-underline-animation"
                style={{ fontSize: 18 }}
                onClick={() => setShowMenuLinks((s) => !s)}
              >
                <a className="font-700" href={url}>
                  HP SitePrint
                </a>
                <svg
                  className={`fill-white mdMenu:hidden mb-1 ${
                    showMenuLinks ? "rotate-svg" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 12 6"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m455.465 769.707-1.847-.974 3.478-5.054-3.475-4.989 1.841-.983 4.156 5.966z"
                    transform="rotate(90 611.663 158.045)"
                  ></path>
                </svg>
              </h2>

              <ul
                className={`w-full flex order-3 mdMenu:order-2 flex-nowrap gap-6 mdMenu:gap-x-7 flex-col mdMenu:flex-row mdMenu:h-full ${
                  showMenuLinks ? "" : "hidden"
                }`}
                role="menubar"
              >
                {secondary.map((item) => (
                  <MenuLink key={item.id} item={item} />
                ))}
              </ul>

              <div className="flex items-center order-2 gap-2 mdMenu:order-3 sm:ml-auto mdMenu:h-full">
                {ctaItems.map((item, index) => {
                  return (
                    <LinkHP
                      key={item.id}
                      to={item.url}
                      className={
                        index !== 0
                          ? "font-bold text-base leading-8 inline-block text-black bg-white hover:bg-grayer transition duration-250 cursor-pointer px-4"
                          : "font-bold inline-block leading-8 border text-white border-transparent cursor-pointer px-4 bg-darkCyanBlue hover:bg-darkerCyanBlue"
                      }
                      title={item.title}
                      aria-label={item.title}
                    >
                      {item.title}
                    </LinkHP>
                  );
                })}
              </div>
            </div>
          </div>
        </Container>
      </nav>

      {showMenuLinks && isTablet ? (
        <div className="fixed top-0 left-0 z-20 w-full h-screen bg-black opacity-75"></div>
      ) : null}
    </>
  );
};

export default Menu;
